<template>
  <div>
    <v-layout wrap justify-start>
      <v-flex xs12 align-self-center text-center>
        <v-layout wrap justify-start pb-5>
          <v-flex xs12 pt-lg-6 pt-md-6 pt-sm-6 pt-xs-2 align-self-center>
            <v-layout wrap justify-start>
              <v-flex xs12 md6 lg6 align-start px-5>
                <v-card>
                  <v-layout wrap justify-center class="homeGmap">
                    <v-flex align-self-center text-center>
                      <span class="heatMap"> Rescues and Sightings</span>
                    </v-flex>
                  </v-layout>
                  <div id="mapneww"></div>
                </v-card>
              </v-flex>

              <v-flex style="background-color: ">
                <v-layout wrap justify-center>
                  <div class="hidden-md-and-down vl"></div>
                </v-layout>
              </v-flex>

              <v-flex xs12 sm12 md5 lg5 pr-lg-12 pl-sm-4 pl-lg-0>
                <v-layout wrap justify-center>
                  <v-flex xs12 sm12 md12 align-self-center pt-md-3 pt-lg-0>
                    <v-layout wrap justify-start>
                      <v-flex pb-lg-2 align-self-start text-left>
                        <span class="headings"> Top species sighted </span>
                      </v-flex>
                    </v-layout>
                    <v-layout wrap justify-center>
                      <v-flex
                        v-for="(item, i) in species"
                        :key="i"
                        align-self-center
                        text-center
                        xs4
                        sm4
                        md4
                        lg4
                        pa-2
                        xl4
                        pr-lg-5
                        pr-xl-5
                      >
                        <v-layout wrap justify-center>
                          <v-flex
                            xs12
                            xl12
                            align-self-center
                            text-center
                            v-if="species[i].turtleImage"
                          >
                            <v-img
                              :src="baseURL + species[i].turtleImage"
                              cover
                              :style="
                                $vuetify.breakpoint.name == 'xl'
                                  ? 'width: 280px;height: 150px'
                                  : (style = 'width:210px;height: 150px')
                              "
                            />
                          </v-flex>
                          <v-flex class="fontts">
                            <span style="font-weight: bold">
                              {{ item.name }}
                            </span>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-flex>

                  <v-flex xs12 sm12 md12 pt-lg-0 align-self-center text-left>
                    <v-layout wrap justify-center>
                      <v-flex pb-lg-2 align-self-center text-left>
                        <span class="headings">Top contributors:</span>
                      </v-flex>
                    </v-layout>
                    <v-layout wrap justify-center>
                      <v-flex
                        v-for="(item, ii) in contributers"
                        :key="contributers[ii].photo"
                        align-self-center
                        text-center
                        pa-2
                        xs4
                        sm4
                        md4
                        lg4
                        xl4
                        pr-lg-5
                        pr-xl-5
                      >
                        <v-img
                          :src="mediaURL + contributers[ii].photo"
                          :style="
                            $vuetify.breakpoint.name == 'xl'
                              ? 'width: 280px;height: 150px'
                              : (style = 'width:210px;height: 150px')
                          "
                          cover
                        />
                      </v-flex>
                      <v-flex
                        class="fontts"
                        style="font-weight: bold"
                        px-2
                        xs4
                        sm4
                        md4
                        lg4
                        xl4
                        pr-lg-5
                        pr-xl-5
                        v-for="(item, iii) in contributers"
                        :key="iii"
                      >
                        {{ contributers[iii].name }}
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script
    src="https://maps.googleapis.com/maps/api/js?libraries=places&key=AIzaSyCaccNxbzwR9tMvkppT7bT7zNKjChc_yAw&libraries=visualization,drawing">
</script>
<script>
var marker;
var drawingManager;
var all_overlays = [];
let heatmap;
export default {
  props: ["mapdata"],
  data() {
    return {
      fill: {
        color: "#5753C4F3",
      },

      data: [],
      species: [],
      contributers: [],
      dataMap1: [],
      map: null,
    };
  },
  watch: {
    mapdata() {
      this.getData();
    },
  },
  mounted() {
    this.getData();
  },
  computed: {
    getdata() {
      return this.mapdata;
    },
  },
  methods: {
    getData() {
      console.log("value is=", this.mapdata);
      for (var i = 0; i < 3; i++) {
        this.contributers.push(this.mapdata.contributers[i]);
        this.species.push(this.mapdata.sightings[i]);
      }
      console.log("sample is=", this.contributers);
      this.dataMap1 = this.mapdata.mapData;
      console.log("datamap is=", this.dataMap);

      var vm = this;
      var mapData = [];
      for (var k = 0; k < vm.dataMap1.length; k++) {
        mapData.push(
          new google.maps.LatLng(
            vm.dataMap1[k].location[1],
            vm.dataMap1[k].location[0]
          )
        );
      }
      vm.map = new google.maps.Map(document.getElementById("mapneww"), {
        zoom: 5,
        center: { lat: 20.38, lng: 80.12 },
        mapTypeId: "satellite",
      });
      heatmap = new google.maps.visualization.HeatmapLayer({
        data: mapData,
        map: vm.map,
      });
    },
  },
};
</script>
<style scoped>
#mapneww {
  height: 430px;
  width: 100%;
  margin: 0px;
  padding: 0px;
}
</style>